define('services/userStatusService',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'services/apiCore',
    'services/localeService',
    'util/errorCallbackFactory'
], function (
    ko,
    _,
    Promise,
    apiCore,
    localeService,
    errorCallbackFactory
) {
    'use strict';

    var PRESENCES = {};
    var OUT_OF_OFFICE_STATUSES = {};
    var ROUTING_STATUSES = {};
    var initialized = ko.observable(false);

    var SYSTEM_PRESENCES = {
        AVAILABLE: '6a3af858-942f-489d-9700-5f9bcdcdae9b',
        AWAY: '5e5c5c66-ea97-4e7f-ac41-6424784829f2',
        BUSY: '31fe3bac-dea6-44b7-bed7-47f91660a1a0',
        OFFLINE: 'ccf3c10a-aa2c-4845-8e8d-f59fa48c58e5',
        IDLE: '7ffa01cd-7866-4ad7-8faa-31e11b42f51f',
        ON_QUEUE: 'e08eaf1b-ee47-4fa9-a231-1200e284798f',
        MEAL: '3fd96123-badb-4f69-bc03-1b1ccc6d8014',
        TRAINING: 'd2390a99-8546-bad9-8f0a-219548e8aeb0',
        MEETING: 'bbdff279-7ae1-48ea-bade-7831d7234c64',
        BREAK: '227b37e2-f1d0-4dd0-8f50-badd7cf6d158'
    };

    var STATUS_TYPES = {
        AVAILABLE:          'userStatus-available',
        AWAY:               'userStatus-away',
        BREAK:              'userStatus-break',
        BUSY:               'userStatus-busy',
        IDLE:               'userStatus-idle',
        MEAL:               'userStatus-meal',
        MEETING:            'userStatus-meeting',
        OFFLINE:            'userStatus-offline',
        ON_QUEUE:           'userStatus-on-queue',
        TRAINING:           'userStatus-training',
        COMMUNICATING:      'userStatus-communicating',
        INTERACTING:        'userStatus-interacting',
        NOT_RESPONDING:     'userStatus-not-responding',
        OUT_OF_OFFICE_ON:   'userStatus-out-of-office-online',
        OUT_OF_OFFICE_OFF:  'userStatus-out-of-office-offline'
    };

    function buildStatusObject (label, type, text, systemPresence) {
        if (label === 'on_queue') {
            label = 'onQueue';
        }

        if (label) {
            text = ko.i18n.renderString('userStatus.' + label);
        }

        var status = {
            label: text,
            type: STATUS_TYPES[type.toUpperCase().replace(" ", "_")]
        };

        if (systemPresence) {
            status.primaryPresence = systemPresence;
        }

        return status;
    }

    function generateRoutingStatusObjects () {
        ROUTING_STATUSES = {
            INTERACTING:    buildStatusObject('interacting', 'INTERACTING'),
            NOT_RESPONDING: buildStatusObject('notResponding', 'NOT_RESPONDING'),
            OFF_QUEUE:      buildStatusObject('offQueue', 'AWAY'),
            IDLE:           buildStatusObject('onQueue', 'ON_QUEUE'),
            COMMUNICATING:  buildStatusObject('communicating', 'COMMUNICATING')
        };
    }

    function generateOOOStatusObjects () {
        OUT_OF_OFFICE_STATUSES = {
            ONLINE:  buildStatusObject('outOfOffice', 'OUT_OF_OFFICE_ON'),
            OFFLINE: buildStatusObject('outOfOffice', 'OUT_OF_OFFICE_OFF')
        };
    }

    function loadPresenceDefinitions (pageSize, pageNumber) {
        return apiCore.v2.get('/presencedefinitions', {
                pageSize: pageSize,
                pageNumber: pageNumber
            })
            .then(function (response) {
                var locale = localeService.getAppLocale().replace('-','_');
                _.forEach(response.entities, function (presence) {
                    if (presence.primary) {
                        var label = presence.systemPresence.toLowerCase().replace(" ", "_");
                        PRESENCES[presence.id] = buildStatusObject(label, presence.systemPresence);
                    } else {
                        // If not a primary presence, try to grab to the label
                        // for the current locale. If that doesn't exist, grab
                        // the first label available in the object hash.
                        var text = presence.languageLabels[locale] ||
                            _.valuesIn(presence.languageLabels)[0];
                        PRESENCES[presence.id] = buildStatusObject('', presence.systemPresence, text, presence.systemPresence);
                    }
                });
                return response;
            });
    }

    function loadPresences () {
        var pageNumber = 1;
        var pageSize = 100;
        return loadPresenceDefinitions(pageSize, pageNumber)
            .then(function (response) {
                var totalPages = _.ceil(response.total/response.pageSize);
                var promises = [];
                while (pageNumber < totalPages) {
                    promises.push(loadPresenceDefinitions(pageSize, ++pageNumber));
                }
                return Promise.all(promises);
            });
    }

    var userStatusService = {

        initialized: ko.computed(function () {
            return initialized();
        }),

        findPresence: function (id) {
            var result = PRESENCES[id];

            if (!result) {
                return buildStatusObject('unknown', 'OFFLINE');
            }

            return result;
        },

        findRoutingStatus: function (status) {
            var result = ROUTING_STATUSES[status];
            if (!result) {
                result = buildStatusObject('unknown', 'OFFLINE');
            }
            return result;
        },

        findOOOStatus: function (status) {
            return OUT_OF_OFFICE_STATUSES[status];
        },

        getUnknownStatus: function () {
            return buildStatusObject('unknown', 'OFFLINE');
        },

        SYSTEM_PRESENCES: SYSTEM_PRESENCES

    };

    ko.computed(function () {
        if (!initialized() && localeService.initialized()) {
            loadPresences()
                .then(function () {
                    // Generate status objects after
                    // strings have been loaded.
                    generateRoutingStatusObjects();
                    generateOOOStatusObjects();
                    initialized(true);
                })
                .catch(errorCallbackFactory.createCallback({
                    namespace: 'presenceDefinition.error'
                }));
        }
    });

    return userStatusService;
});

